// extracted by mini-css-extract-plugin
export default {"link":"dcc_wheelEfficiencyLabel-link","disclaimer":"dcc_wheelEfficiencyLabel-disclaimer"};